<template>
  <div id="app">
    <div class="container" style="padding-top: 80px; overflow-x: hidden;">

      <div class="hero_m">
        <div class="title">{{$t("become_signal_provider")}}</div>
        <div class="text">{{$t("commission_and_profit_sharing")}}</div>
        <div class="btn_box" @click="goApply">{{ $t("apply_now") }}</div>
      </div>

      <div class="hero">
        <div class="modle_line  modle_line1">{{ $t("contract") }}</div>
        <div class="apply_for_box">
          <img src="../assets/css/icon/fanyong.png" alt="">
          <span>{{ $t('commission_and_profit_sharing') }}</span>
          <div class="btn_box" @click="goApply">{{ $t("apply_now") }}</div>

        </div>

        <div class="swiper_box">
          <div class="left_box">
            <div class="title">{{ $t("become_leader") }}</div>
            <div class="btn_box" @click="goApply">{{ $t("apply_now") }}</div>
            <div class="alert_box">
              <img class="gg1" src="../assets/css/icon/gg.png" alt="">
              <img class="gg2" src="../assets/css/icon/gg@2x.png" alt="">
              <span style="font-family: 'HarmonyOS Sans SC'">{{ $t("fufuture_copy_trading") }}</span>
              <img class="gengduo" style="width: 8px" src="../assets/css/icon/more.png" alt="">
            </div>
          </div>
          <div class="right_box">
            <el-carousel trigger="click" height="150px">
              <el-carousel-item v-for="item in 3" :key="item">
                <div class="lbt_box">
                  <span>{{ $t("how_to_start_copy_trading") }}</span>
                  <img src="../assets/css/icon/lbt.png" alt="">
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <div class="project ">
        <div class="modle_line_box" style="align-items: center;">
          <div class="modle_line modle_line2">
            {{ $t("contract") }}
          </div>
          <div class="modle_line" @click="$router.push({ path: '/tapeOrder'})">
            {{ $t("my_leader") }}
          </div>
          <div class="filter-bar filter-bar22">
            <el-select class="select_down" popper-class="custom-select-dropdown" v-model="value1" :style="{width:value1Width}">
              <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                <div style="display: flex;flex-direction: row;align-items: center">
                  {{ item.label }}
                  &nbsp;&nbsp;
                  <img class="select_icon" src="../assets/css/icon/gg.svg" style="width: 8px;height: 6px;"/>
                </div>
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="filter-bar filter-bar11">
          <el-select class="select_down" :style="{width:value1Width}" popper-class="custom-select-dropdown" v-model="value1" >
            <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              <div style="display: flex;flex-direction: row;align-items: center">
                {{ item.label }}
                &nbsp;&nbsp;
                <img class="select_icon" src="../assets/css/icon/gg.svg" style="width: 8px;height: 6px;"/>
              </div>
            </el-option>
          </el-select>
          <div class="ml-auto" v-if="false">
            <img @click="search()" src="../assets/css/icon/lujing.png" alt="">
            <img @click="shaixuan()" src="../assets/css/icon/shaixuan.png" alt="">
            <img @click="VS()" src="../assets/css/icon/VS.png" alt="">
          </div>
        </div>

        <div class="card-grid" v-loading="allLoading" element-loading-background="rgba(0, 0, 0, 0.8)" >
          <div class="card"
               @click="goDetail(item)"
               v-for="(item,index) in showAllTraders" :key="index">
            <div class="card-header">
              <img class="User_avatar" :src="item.img" alt="User Avatar">
              <div>
                {{ item.username }} {{
                  item.dotAddress
                }}
                <div class="people_box">
                  <img src="../assets/css/icon/people.png">
                  <span>{{ item.molecule }}/{{ item.denominator }}</span>
                </div>
              </div>
              <div class="start_icon">
                <svg t="1745751991956" v-show="item.isStar===0" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="6229" width="200" height="200">
                  <path
                      d="M557.27 124.36l95.42 193.36A50.9 50.9 0 0 0 691 345.55l213.38 31c41.73 6.06 58.4 57.35 28.2 86.79l-154.4 150.5a50.9 50.9 0 0 0-14.64 45L800 871.4c7.13 41.57-36.5 73.27-73.83 53.64L535.31 824.71a50.83 50.83 0 0 0-47.35 0L297.11 925c-37.33 19.63-81-12.07-73.83-53.64l36.45-212.51a50.89 50.89 0 0 0-14.63-45L90.7 463.35c-30.2-29.44-13.54-80.73 28.2-86.79l213.37-31a50.9 50.9 0 0 0 38.31-27.83L466 124.36c18.67-37.81 72.6-37.81 91.27 0z"
                      fill="#474D57" p-id="6230"></path>
                </svg>
                <svg t="1745751991956" v-show="item.isStar===1" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="6229" width="200" height="200">
                  <path
                      d="M557.27 124.36l95.42 193.36A50.9 50.9 0 0 0 691 345.55l213.38 31c41.73 6.06 58.4 57.35 28.2 86.79l-154.4 150.5a50.9 50.9 0 0 0-14.64 45L800 871.4c7.13 41.57-36.5 73.27-73.83 53.64L535.31 824.71a50.83 50.83 0 0 0-47.35 0L297.11 925c-37.33 19.63-81-12.07-73.83-53.64l36.45-212.51a50.89 50.89 0 0 0-14.63-45L90.7 463.35c-30.2-29.44-13.54-80.73 28.2-86.79l213.37-31a50.9 50.9 0 0 0 38.31-27.83L466 124.36c18.67-37.81 72.6-37.81 91.27 0z"
                      fill="#A5D63F" p-id="6230"></path>
                </svg>
              </div>
            </div>
            <div class="card_line_box">
              <div class="left">
                <div class="card_info">{{$t('unrealized_profit_loss')}}</div>
                <div class="card-value" :style="{color:Number(item.unpnl)>=0?'#56BA56FF':'rgba(239, 69, 74, 1)',fontSize:'20px'}">
                  {{item.unpnl}}({{item.unpnlRate}}%)
                </div>
              </div>
              <div class="right" style="width: 180px;text-align: right;margin-right: 0px;">
                <div class="card_info">{{$t("realized_profit_loss")}}</div>
                <div class="card-value" :style="{color:item.pnl>=0?'#56BA56FF':'rgba(239, 69, 74, 1)',fontSize:'16px',fontWeight:400}">
                  {{item.pnl.toFixed(2)}}
                </div>
              </div>
            </div>
            <div class="card-details">
              <div>{{ $t("aum") }}<br>{{ item.scale }}</div>
              <div>{{ $t("trading_currency") }}<br>{{ item.currency }}</div>
              <div style="width: 150px;text-align: right;word-break: break-all;">{{$t("copy_trader_address")}}<br>{{ item.trader }}</div>
            </div>
            <div
                @click="goDetail(item,true)"
                class="card-button">{{ $t("copy_trading") }}
            </div>
          </div>
          <div class="card" v-if="!isMobile&&showAllTraders.length%3 === 2"
               style="border: 1px solid transparent;background: transparent"></div>
        </div>
        <div class="pagination_box">
          <span>{{ $t("update_every_ten_minutes") }}</span>
          <el-pagination @prev-click="prevClick()"
                         @next-click="nextClick()"
                         :page-size="pageSize"
                         :current-page.sync="currentPage"
                         layout="prev, pager, next"
                         :total="allTraders.length"/>
        </div>

      </div>
      <div class="project" style=" margin-top: 90px">
        <div class="modle_line" style="border: 0">{{ $t("my_copy_contract") }}</div>
        <div class="card-grid" style="margin-top: 7px" v-loading="listLoading" element-loading-background="rgba(0, 0, 0, 0.8)" >
          <div class="card"
               @click="goDetail(item)"
               v-for="(item,index) in showList" :key="index">
            <div class="card-header">
              <img class="User_avatar" :src="item.img" alt="User Avatar">
              <div>
                {{ item.username }} {{ item.dotAddress }}
                <div class="people_box">
                  <img src="../assets/css/icon/people.png">
                  <span>{{ item.molecule }}/{{ item.denominator }}</span>
                </div>
              </div>
              <div class="start_icon">
                <svg t="1745751991956" v-show="item.isStar===0" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="6229" width="200" height="200">
                  <path
                      d="M557.27 124.36l95.42 193.36A50.9 50.9 0 0 0 691 345.55l213.38 31c41.73 6.06 58.4 57.35 28.2 86.79l-154.4 150.5a50.9 50.9 0 0 0-14.64 45L800 871.4c7.13 41.57-36.5 73.27-73.83 53.64L535.31 824.71a50.83 50.83 0 0 0-47.35 0L297.11 925c-37.33 19.63-81-12.07-73.83-53.64l36.45-212.51a50.89 50.89 0 0 0-14.63-45L90.7 463.35c-30.2-29.44-13.54-80.73 28.2-86.79l213.37-31a50.9 50.9 0 0 0 38.31-27.83L466 124.36c18.67-37.81 72.6-37.81 91.27 0z"
                      fill="#474D57" p-id="6230"></path>
                </svg>
                <svg t="1745751991956" v-show="item.isStar===1" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="6229" width="200" height="200">
                  <path
                      d="M557.27 124.36l95.42 193.36A50.9 50.9 0 0 0 691 345.55l213.38 31c41.73 6.06 58.4 57.35 28.2 86.79l-154.4 150.5a50.9 50.9 0 0 0-14.64 45L800 871.4c7.13 41.57-36.5 73.27-73.83 53.64L535.31 824.71a50.83 50.83 0 0 0-47.35 0L297.11 925c-37.33 19.63-81-12.07-73.83-53.64l36.45-212.51a50.89 50.89 0 0 0-14.63-45L90.7 463.35c-30.2-29.44-13.54-80.73 28.2-86.79l213.37-31a50.9 50.9 0 0 0 38.31-27.83L466 124.36c18.67-37.81 72.6-37.81 91.27 0z"
                      fill="#A5D63F" p-id="6230"></path>
                </svg>
              </div>
            </div>
            <div class="card_line_box">
              <div class="left">
                <div class="card_info">{{$t('unrealized_profit_loss')}}</div>
                <div class="card-value" :style="{color:Number(item.unpnl)>=0?'#56BA56FF':'rgba(239, 69, 74, 1)',fontSize:'20px'}">
                  {{item.unpnl}}({{item.unpnlRate}}%)
                </div>
              </div>
              <div class="right" style="width: 180px;text-align: right;margin-right: 0px;">
                <div class="card_info">{{$t("realized_profit_loss")}}</div>
                <div class="card-value" :style="{color:Number(item.unpnl)>=0?'#56BA56FF':'rgba(239, 69, 74, 1)',fontSize:'16px',fontWeight:400}">
                  {{item.pnl.toFixed(2)}}
                </div>
              </div>
            </div>
            <div class="card-details">
              <div>{{ $t("aum") }}<br>{{ item.scale }}</div>
              <div>{{ $t("trading_currency") }}<br>{{ item.currency }}</div>
              <div style="width: 150px;text-align: right;word-break: break-all;">{{$t("copy_trader_address")}}<br>{{ item.trader }}</div>
            </div>
            <div
                @click="goDetail(item,true)"
                class="card-button">{{ $t("copy_trading") }}
            </div>
          </div>
          <div class="card" v-if="!isMobile&&showList.length%3 === 2"
               style="border: 1px solid transparent;background: transparent"></div>
        </div>
        <div class="pagination_box">
          <span>{{ $t("update_every_ten_minutes") }}</span>
          <el-pagination @prev-click="prevList"
                         @next-click="nextList"
                         :current-page="listPage"
                         layout="prev, pager, next" :total="pageSize"/>
        </div>
      </div>

      <faq></faq>


    </div>
  </div>
</template>

<style scoped lang="scss">
.select_down {
  ::v-deep .el-input__suffix {
    .el-input__suffix-inner {
      .el-select__caret {
        font-family: 'element-icons' !important;

        &.el-icon-arrow-up::before {
          content: "\e78f";
        }

        &.el-icon-arrow-down::before {
          content: "\e790";
        }
      }
    }
  }
}


</style>

<script>
import {
  createAndCall,
  createLeadingContractAndCall, getAllTokenFromCache,
  getContract, getContractOrder, getContractOrder2, getContractWithCache,
  getErc20Info,
  getLeadingInfo, getProvider, getSelectTokenInfo
} from "../utils/contract";
import {getAccount, getChainId, getChainName} from "../utils/wallet";
import {Contract, Method, Underling} from "../config/const";
import {BigNumber, ethers,ContractInterface} from "ethers";
import NoAxisLineChart from '../components/NoAxisLineChart';
import {getDotAddress, getTextWidth} from "../utils/strings";
import {
  consoleTime,
  getForcePriceV2,
  getSecurityRate2,
  isMobile,
  transBig2number,
  transNumber2Big
} from "../utils/functions";
import faq from '../components/faq';
import {getLastPrice, registerService, removeService} from "../service/priceService";
import {getHistoryData, getHistoryDataAllSell} from "../service/queryService";
import orderAbi from "../abi/Orders.json";
import {MESSAGE, registerMessage, removeMessage} from "../utils/message";
import axios from "axios";

export default {
  name: 'Home',
  components: {
    NoAxisLineChart,
    faq
  },
  data() {
    return {
      msg: this.$t("fufuture_copy_trading"),
      list: [],
      showList: [],
      allTraders: [],
      showAllTraders: [],
      pageSize: 6,
      currentPage: 1,
      listPage: 1,
      isMobile: false,
      options: [
        {
          value: '1',
          label: this.$t('today')
        }, {
          value: '7',
          label: this.$t('one_week')
        }, {
          value: '15',
          label: this.$t('half_month')
        }, {
          value: '30',
          label: this.$t('thirty_days')
        }
      ],
      value1: '0',
      value1Width:"88px",
      options1: [
        {
          value: "0",
          label: this.$t('return_rate3')
        },
        {
          value: '1',
          label: this.$t("realized_profit_loss")
        }, {
          value: '2',
          label: this.$t("aum")
        }
      ],
      value: '7',
      valueWidth:"75px",
      checked: true,
      typeqqq: 0,
      questionA: '',
      listLoading:false,
      allLoading:false,
      value1HasRank:false
    };
  },

  methods: {
    prevClick(e) {
      this.currentPage--
      this.getPageData(this.showAllTraders, this.allTraders, this.currentPage)
    },
    goApply(){
      console.log("begin go apply");
      setTimeout(()=>{
        console.log("has go apply");
        this.$router.push({ path: '/applyFor'})
      },0)
    },
    nextClick() {
      this.currentPage++
      this.getPageData(this.showAllTraders, this.allTraders, this.currentPage)
    },
    prevList() {
      this.listPage--
      this.getPageData(this.showList, this.list, this.listPage)
    },
    nextList() {
      this.listPage++
      this.getPageData(this.showList, this.list, this.listPage)
    },
    async getAllTradersFromCache(){
      try{
        let orders=await axios.get("https://a.fufuture.io/getFollowList?net="+await getChainName())
        if(!orders || !orders.data){
          return null;
        }
        for(const item of orders.data){
          const names=["BTC","ETH","SOL"]
          for(const name of names){
            if(item[name+"_1"]){
              item[name+"_1"].frezz=BigNumber.from(item[name+"_1"].freeze);
              item[name+"_1"].margin=BigNumber.from(item[name+"_1"].margin);
              item[name+"_1"].size=BigNumber.from(item[name+"_1"].size);
              item[name+"_1"].value=BigNumber.from(item[name+"_1"].value);
            }
            if(item[name+"_2"]){
              item[name+"_2"].frezz=BigNumber.from(item[name+"_2"].freeze);
              item[name+"_2"].margin=BigNumber.from(item[name+"_2"].margin);
              item[name+"_2"].size=BigNumber.from(item[name+"_2"].size);
              item[name+"_2"].value=BigNumber.from(item[name+"_2"].value);
            }
          }
          item.trader=getDotAddress(item.trader)
        }
        return orders.data;
      }catch (e){
        console.log("Error is",e);
        return null;
      }

    },
    async getAllTraders() {
      this.allLoading=true;

      let data=await this.getAllTradersFromCache();
      if(!data){
        await this.getTraders(this.allTraders, Method.getAllLeadingContractInfo, this.value);
        await this.getTraderInfo(this.allTraders);
      }else{
        this.allTraders=data;
      }

      this.rankData(this.allTraders);
      await this.getPageData(this.showAllTraders, this.allTraders, this.currentPage)
    },
    async getPageData(showData, allTraders, currentPage) {
      showData.length = 0;
      let end = (currentPage) * this.pageSize;
      if (allTraders.length < end) {
        end = allTraders.length;
      }
      let slice = allTraders.slice((currentPage - 1) * this.pageSize, end);
      showData.push(...slice);
      return showData;
    },

    rankData(allTraders){
      if (this.value1 == 0) {
        allTraders = allTraders.sort((e1, e2) => {
          let rankSub=Number(e2.unpnlRate) - Number(e1.unpnlRate);
          return rankSub;
        })
      }else if(this.value1==1){
        allTraders=allTraders.sort((t1, t2) => {
          return t2.pnl-t1.pnl;
        })
      } else if (this.value1 == 2) {
        allTraders = allTraders.sort((e1, e2) => {
          return e2.scale - e1.scale;
        })
      }
    },

    async getTraderInfo(allTraders) {
      let tokenAddress = [];
      let contractAddress = [];
      for (let i in allTraders) {
        let trade = allTraders[i];
        tokenAddress.push(trade.token);
        contractAddress.push(trade.contractAddress);
      }
      let rest = await getErc20Info(tokenAddress);
      for (let i in rest) {
        allTraders[i].currency = rest[i];
      }
      let contractInfo;
      contractInfo = await getLeadingInfo(contractAddress);
      for (let i = 0; i < contractInfo.length; i += 6) {
        allTraders[i / 6].molecule = contractInfo[i + 1].length;
        allTraders[i / 6].denominator = contractInfo[i + 2].length;
        allTraders[i / 6].scale = transBig2number(contractInfo[i + 5].assetAmount);
        allTraders[i / 6].trader = getDotAddress(contractInfo[i+3].traderAddress);
      }
    },
    async getTraders(allTraders, method, ...args) {
      let traders = await createAndCall(Contract.LeadingContractFactory, method, ...args);
      let newTraders = [...traders];

      newTraders.sort((t1, t2) => {
        return parseFloat(t2.createTime.toString()) - parseFloat(t1.createTime.toString())
      })

      allTraders.length = 0;
      for (let i in newTraders) {
        let trade = newTraders[i];

        const des=trade.traderDescription;
        const desArr=des.split("$^");
        let headUrl="";
        if(desArr.length>1){
          headUrl=desArr[desArr.length-1];
        }
        if(headUrl){
          if(!headUrl.startsWith("http")){
            headUrl="https://admin.fufuture.io"+headUrl;
          }
        }else{
          headUrl=require("../assets/css/icon/head.svg")
        }


        allTraders.push({
          username: trade.traderName,
          type: 0,
          number: '0',
          yield: '0',
          scale: '0',
          day7: '0',
          currency: '',
          molecule: '',
          recentTotalBalance:trade.recentTotalBalance,
          recentTotalShare:trade.recentTotalShare,
          denominator: '',
          contractAddress: trade.contractAddress,
          dotAddress: getDotAddress(trade.contractAddress),
          token: trade.tokenAddress,
          createTime: trade.createTime.toString(),
          pnl:0,
          img:headUrl
        })
      }

      this.allLoading=false;
      await this.getOrderInfo(allTraders)
      await this.getPnl(allTraders)
    },


    async getMyTrader() {
      let address = await getAccount();
      if(!address){
        return ;
      }
      this.listLoading=true;
      await this.getTraders(this.list, Method.getUserFollowedContracts, address);
      this.listLoading=false;
      await this.getTraderInfo(this.list);

      await this.getPageData(this.showList, this.list, this.listPage)

    },


    shaixuan() {
    },
    search() {
    },
    VS() {
    },
    change(n) {
      this.typeqqq = n
    },
    goDetail(item,isFollow=false){
      console.log("go detail");
      setTimeout(()=>{
        console.log("has detail");
        if(document.body.clientWidth>750){
          this.$router.push({ path: '/listPage',query:{contract:item.contractAddress,token:item.token,follow:isFollow}})
        }else{
          this.$router.push({ path: '/listMobile',query:{contract:item.contractAddress,token:item.token,follow:isFollow}})
        }
      },0)

    },
    async getOrderInfo(traders){
      let allCalls=[];
      for(let i in traders){
        let item=traders[i];
        let selectToken=await getSelectTokenInfo(item.token)
        let calls=await getContractOrder2(item.token,item.contractAddress,selectToken.orderBook);
        allCalls=allCalls.concat(calls);
      }

      let results=await Promise.all(allCalls);
      for(let i =0 ;i<results.length;i+=6){
        let btc1={...results[i]};
        let btc2={...results[i+1]};
        let eth1={...results[i+2]};
        let eth2={...results[i+3]};
        let sol1={...results[i+4]};
        let sol2={...results[i+5]};

        if(btc1 && btc1.size && btc1.size.gt(BigNumber.from(0))){
          btc1.price = parseFloat((btc1.value.mul(BigNumber.from(10000)).div(btc1.size)).toString()) / 10000;
          traders[i/6].BTC_1=btc1;
          traders[i/6].BTC_1.direct=1;
          traders[i/6].BTC_1.vol=transBig2number(btc1.size);
          traders[i/6].BTC_1.name="BTC";
        }

        if(btc2 && btc2.size && btc2.size.gt(BigNumber.from(0))){
          btc2.price = parseFloat((btc2.value.mul(BigNumber.from(10000)).div(btc2.size)).toString()) / 10000;
          traders[i/6].BTC_2=btc2;
          traders[i/6].BTC_2.direct=2;
          traders[i/6].BTC_2.vol=transBig2number(btc2.size);
          traders[i/6].BTC_2.name="BTC";
        }

        if(eth1 && eth1.size && eth1.size.gt(BigNumber.from(0))){
          eth1.price = parseFloat((eth1.value.mul(BigNumber.from(10000)).div(eth1.size)).toString()) / 10000;
          traders[i/6].ETH_1=eth1;
          traders[i/6].ETH_1.direct=1;
          traders[i/6].ETH_1.vol=transBig2number(eth1.size);
          traders[i/6].ETH_1.name="ETH";
        }

        if(eth2 && eth2.size && eth2.size.gt(BigNumber.from(0))){
          eth2.price = parseFloat((eth2.value.mul(BigNumber.from(10000)).div(eth2.size)).toString()) / 10000;
          traders[i/6].ETH_2=eth2;
          traders[i/6].ETH_2.direct=2;
          traders[i/6].ETH_2.vol=transBig2number(eth2.size);
          traders[i/6].ETH_2.name="ETH";
        }

        if(sol1 && sol1.size && sol1.size.gt(BigNumber.from(0))){
          sol1.price = parseFloat((sol1.value.mul(BigNumber.from(10000)).div(sol1.size)).toString()) / 10000;
          traders[i/6].SOL_1=sol1;
          traders[i/6].SOL_1.direct=1;
          traders[i/6].SOL_1.vol=transBig2number(sol1.size);
          traders[i/6].SOL_1.name="SOL";
        }

        if(sol2 && sol2.size && sol2.size.gt(BigNumber.from(0))){
          sol2.price = parseFloat((sol2.value.mul(BigNumber.from(10000)).div(sol2.size)).toString()) / 10000;
          traders[i/6].SOL_2=sol2;
          traders[i/6].SOL_2.direct=2;
          traders[i/6].SOL_2.vol=transBig2number(sol2.size);
          traders[i/6].SOL_2.name="SOL";
        }
      }


    },
    calcuRate(order) {
      if (order.orderType == 1 || order.orderType == 2) {
        return "0";
      }

      let sub = BigNumber.from(0);
      if (order.direction == 1) {
        sub = BigNumber.from(order.price).sub(BigNumber.from(order.costPrice));
      } else {
        sub = BigNumber.from(order.costPrice).sub(BigNumber.from(order.price));
      }

      return transBig2number(sub.mul(order.amount).div(BigNumber.from("1000000000000000000")));
    },
    async getPnl(traders){
      let addr=[];
      for(let i in traders){
        addr.push(traders[i].contractAddress.toLowerCase());
      }
      let orders=await getHistoryDataAllSell(addr);
      let profitMap={};
      for(let i in orders.orderHistories){
        let item=orders.orderHistories[i];
        let profit=this.calcuRate(item);

        if(!profitMap[item.taker]){
          profitMap[item.taker]=0;
        }
        profitMap[item.taker]+=parseFloat(profit);
        let fee=parseFloat(transBig2number(BigNumber.from(item.tradingFee)));
        profitMap[item.taker]-=fee
      }
      for(let i in traders){
        traders[i].pnl=profitMap[traders[i].contractAddress.toLowerCase()]??0;
      }

    },
    async updateMessage(msg,data){
      if(msg==MESSAGE.CHAIN_UPDATE){
        this.getAllTraders()
        this.getMyTrader()
      }
    },
    async updatePrice(prices){
      try {
        this.currentPrice = {
          BTC: transBig2number(prices[Underling.BTC].price, prices[Underling.BTC].decimal),
          ETH: transBig2number(prices[Underling.ETH].price, prices[Underling.ETH].decimal)
        }

        for (let i in this.allTraders) {
          let item=this.allTraders[i];
          let array=[item.BTC_1,item.BTC_2,item.ETH_1,item.ETH_2];

          let panTotal = 0;
          let marginTotal = 0;

          for(let j in array){
            let item1=array[j];
            if(!item1 || item1.size.eq(BigNumber.from(0))){
              continue;
            }
            let name = item1.name ?? "BTC";
            let currPrice = transBig2number(prices[name].price, prices[name].decimal);
            let pan = 0;
            let sub = 0;
            if (item1.direct==1) {
              sub = parseFloat(currPrice) - parseFloat(item1.price);
            } else {
              sub = -(parseFloat(currPrice) - parseFloat(item1.price));
            }
            pan = (sub * parseFloat(transBig2number(item1.size)));
            panTotal+=pan;
            marginTotal+=parseFloat(transBig2number(item1.margin));
          }

          this.allTraders[i].unpnl=panTotal.toFixed(2);
          if(marginTotal>0){
            this.allTraders[i].unpnlRate=(panTotal*100/marginTotal).toFixed(2);
          }else{
            this.allTraders[i].unpnlRate=0;
          }
        }

        if(this.allTraders && this.allTraders[0] && this.allTraders[0].trader){ //如果数据完备，则进行排序
          this.rankData(this.allTraders)
        }
        this.getPageData(this.showAllTraders, this.allTraders, this.currentPage)
        this.$forceUpdate()

        for (let i in this.list) {
          let item=this.list[i];
          let array=[item.BTC_1,item.BTC_2,item.ETH_1,item.ETH_2];

          let panTotal = 0;
          let marginTotal = 0;

          for(let j in array){
            let item1=array[j];
            if(!item1 || item1.size.eq(BigNumber.from(0))){
              continue;
            }
            let name = item1.name ?? "BTC";
            let currPrice = transBig2number(prices[name].price, prices[name].decimal);
            let pan = 0;
            let sub = 0;
            if (item1.direct==1) {
              sub = parseFloat(currPrice) - parseFloat(item1.price);
            } else {
              sub = -(parseFloat(currPrice) - parseFloat(item1.price));
            }
            pan = (sub * parseFloat(transBig2number(item1.size)));
            panTotal+=pan;
            marginTotal+=parseFloat(transBig2number(item1.margin));
          }

          this.list[i].unpnl=panTotal.toFixed(2);
          if(marginTotal>0){
            this.list[i].unpnlRate=(panTotal*100/marginTotal).toFixed(2);
          }else{
            this.list[i].unpnlRate=0;
          }
        }
        this.$forceUpdate()

      } catch (e) {
        console.log("error is", e);
      }
    }

  },
  created() {
    this.isMobile = isMobile();
    this.getAllTraders();
    this.getMyTrader();
  },
  watch: {
    currentPage(val1, val2) {
      this.getPageData(this.showAllTraders, this.allTraders, val1)
    },
    listPage(val1, val2) {
      this.getPageData(this.showList, this.list, val1)
    },
    value(val1) {
      let label="";
      for(let i in this.options){
        if(this.options[i].value==val1){
          label=this.options[i].label;
        }
      }
      this.valueWidth=(getTextWidth(label)+38)+"px";
      this.getAllTraders();
    },
    value1(val){

      let label="";
      for(let i in this.options1){
        if(this.options1[i].value==val){
          label=this.options1[i].label;
          break;
        }
      }
      this.value1Width=(getTextWidth(label)+38)+"px";
      this.rankData(this.allTraders);
      this.getPageData(this.showAllTraders, this.allTraders, this.currentPage)
    }
  },
  mounted() {
    this.isMobile = isMobile()
    registerService(this.updatePrice)
    document.getElementById("header").style.display = "flex";
    document.getElementById("footer").style.display = "flex";
    registerMessage(this.updateMessage)
  },
  unmounted(){
    removeService(this.updatePrice)
    removeMessage(this.updateMessage)
  }


}
</script>
<style src="../assets/css/celect.css"></style>
<style scoped lang="scss">



@font-face {
  font-family: 'HarmonyOS Sans SC';
  src: url('https://upload.fufuture.io/tff/HarmonyOS_Sans_SC_Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

.lbt_box {
  display: flex;
  align-items: center;

  img {
    width: 85px;
    height: 90px;
    margin-top: 35px;
    margin-left: 100px;
  }

  span {
    font-size: 24px;
    font-weight: 700;
    margin-top: 50px;
    margin-left: 22px;
  }
}

::v-deep .el-carousel__indicators--horizontal {
  left: 22%;
}

.alert_box {
  width: 365px;
  display: flex;
  align-items: center;
  margin-top: 22px;

  img {
    width: 14px;
    height: 14px;
  }

  span {
    display: inline-block;
    width: 100%;
    margin-left: 8px;
    font-size: 14px;
  }
}

::v-deep .el-input--suffix .el-input__inner {
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  border-radius: 8px;
  background: #181A20;
  border: 1px solid #EAECEF66 !important;
  padding-left: revert;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ffffff;
  border-bottom: 1px dashed rgba(234, 236, 239, 1);
  padding-left: 0;
  margin-left: 8px;
}

::v-deep .el-carousel__button {
  width: 8px !important;
}

::v-deep .el-carousel__indicators--horizontal {
  left: 11%;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ffffff;
  border-color: #ffffff;
}

::v-deep .el-checkbox__inner::after {
  border: 1px solid #181A20;
  border-left: 0;
  border-top: 0;
}

.ml-auto img {
  width: 18px;
  //height: 18px;
}

.card_line_box {
  display: flex;
  height: 100px;
  align-items: center;
  margin-top: 10px;
  .left {
    flex: 1;
  }

  .right {
    width: 120px;
    margin-right: 35px;
  }
}

.pagination_box {
  margin-top: 20px;
  width: 100%;

  .el-pagination {
    float: right !important;
  }

  span {
    float: left !important;
    color: rgba(234, 236, 239, 0.5);
    margin-top: 10px;
    //margin-left: 10px;
  }
}

::v-deep .el-carousel__item.is-active {
  z-index: 0 !important;
}

.card-header {
  position: relative;

  .start_icon {
    position: absolute;
    right: 0;
    //top: -6px;
    svg {
      width: 20px;
      height: 20px;
    }

  }
}

/* 移动端样式 */
@media (max-width: 750px) {
  .people_box {
    background: rgb(39, 44, 28);

    img {
      width: 9px;
      height: 8px;
    }
  }
}

</style>
<style lang="scss" src="../assets/css/mobile.scss"></style>
